export const BUILDER_ADD_ROW = 'BUILDER_ADD_ROW';
export const BUILDER_ADD_SUB = 'BUILDER_ADD_SUB';
export const BUILDER_DELETE_ROW = 'BUILDER_DELETE_ROW';
export const BUILDER_CHANGE_VALUE = 'BUILDER_CHANGE_VALUE';
export const BUILDER_SET_APPLY = 'BUILDER_SET_APPLY';
export const BUILDER_TOGGLE_APPLY = 'BUILDER_TOGGLE_APPLY';
export const BUILDER_SET = 'BUILDER_SET';
